<div class="row" *ngIf="hasError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages"><button>{{ error }}</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="row">
    <div class="col-24">
        <h1>Agent Check List</h1>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p>
            Please send all pages of the signed, completed application and the Scope of Appointment to
            {{insuranceCompany}} within 24 hours of portal entry. Choose one of the following options:
        </p>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p><strong>Email:</strong> Enrollment.Verification&#64;CVSHealth.com</p>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p><strong>Fax to:</strong> 1-866-552-6205</p>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p class="reg-space"><strong>Mail:</strong></p>
        <p class="reg-space">SilverScript Insurance Company</p>
        <p class="reg-space">Attn: Agent Processing</p>
        <p class="reg-space">P.O. Box 30001</p>
        <p>Pittsburgh PA 15222-0330</p>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="Confirm()">Confirm</button>
        <button class="button cancel" (click)="Back()">Go Back</button>
    </div>
</div>
